import type { OrganizationRoleName } from '../lib/types';

const LABELS: Record<OrganizationRoleName, string> = {
    principal: 'Your company',
    subsidiary: 'Subsidiary',
};

// The workspace's company, or another company in its group.
export default function OrganizationRole({ role }: { role?: OrganizationRoleName | null }) {
    if (!role) return null;
    return (
        <span className="ml-1.5 px-1.5 py-0.5 rounded-md bg-navy/10 text-navy text-[11px] font-medium whitespace-nowrap">
            {LABELS[role]}
        </span>
    );
}
